export default "__VITE_ASSET__bRG$9$jJ__"